import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';

import { DonutChart } from '@warrenbrasil/nebraska-web';
import { ChartSummary } from './components/ChartSummary';

import { PortfolioSection } from '@/modules/wealth/services/portfolio';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

interface Props {
  sections: PortfolioSection[];
  totalBalance?: string;
  updatedAt?: string;
  isLoading: boolean;
  hasError: boolean;
}
interface Emits {
  (e: 'on-retry'): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AllocationChart',
  props: {
    sections: null,
    totalBalance: null,
    updatedAt: null,
    isLoading: { type: Boolean },
    hasError: { type: Boolean }
  },
  emits: ["on-retry"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'on-retry'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  sections: PortfolioSection[];
  totalBalance?: string;
  updatedAt?: string;
  isLoading: boolean;
  hasError: boolean;
}





const selectedSectionIndex = ref<number | null>(null);

const dataSet = computed(() => {
  return props.sections.map(section => ({
    name: section.name,
    color: section.color,
    y: section.balance.value
  }));
});

const chartSummaryData = computed(() => {
  if (selectedSectionIndex.value === null) {
    return {
      head: 'Total alocado',
      title: props.totalBalance,
      subtitle: props.updatedAt
    };
  }

  const sectionSelected = props.sections[selectedSectionIndex.value];

  return {
    head: 'Total alocado',
    title: sectionSelected.balance.formatted,
    subtitle: sectionSelected.name
  };
});

const emitOnRetry = () => {
  emit('on-retry');
};

const onHoverAllocation = (index: number | null) => {
  selectedSectionIndex.value = index;
};

return { __sfc: true,props, emit, selectedSectionIndex, dataSet, chartSummaryData, emitOnRetry, onHoverAllocation, DonutChart, ChartSummary, NebraskaColors }
}

})